import type { ReactNode } from 'react';

import StatisticsRow from '../StatisticsRow';
import StatisticsNumber from '../StatisticsNumber';
import StatisticsLabel from '../StatisticsLabel';

interface RowComparisonEventProps {
  /** Additional CSS classes to apply to the row container. */
  className?: string;
  /** Optional CSS classes to apply to the number columns. */
  numberColumnClassName?: string;
  /** Optional icon to display alongside the label. */
  icon?: ReactNode;
  /** Label describing the statistic, e.g. "Games Played", "% Victory". */
  label: string;
  /** Number for the home team. */
  homeNumber: number;
  /** Number for the away team. */
  awayNumber: number;
}

export default function RowComparisonEvent({
  className = '',
  numberColumnClassName = '',
  icon,
  label,
  homeNumber,
  awayNumber,
}: RowComparisonEventProps) {
  return (
    <StatisticsRow className={className}>
      <StatisticsNumber className={numberColumnClassName}>{homeNumber}</StatisticsNumber>
      <div className="flex items-center gap-1 min-w-0 max-w-full">
        {icon}
        <StatisticsLabel className="flex-1 truncate">{label}</StatisticsLabel>
      </div>
      <StatisticsNumber className={`[direction:rtl] ${numberColumnClassName}`}>
        {awayNumber}
      </StatisticsNumber>
    </StatisticsRow>
  );
}
